
import { Component, Vue, Prop } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';

if (process.env.NODE_ENV === 'development') {
  const MockAdapter = require('axios-mock-adapter');
  const mock = new MockAdapter(axios);
  mock.onGet(`${process.env.VUE_APP_API_ENDPOINT}/unauthorized/privacy_policy_revision_date`).reply(200, {
    revisionDate: '2023-07-01'
  });
  mock.onGet(`${process.env.VUE_APP_API_ENDPOINT}/unauthorized/privacy_policy_third_parties`).reply(200, {
    thirdParties: {
      ja: ['a', 'b', 'c'],
      en: ['x', 'y', 'z']
    }
  });
}

type ResponsePrivacyPolicy = { thirdParties: Record<string, string[]> };
type ResponseRevisionDate = { revisionDate: string };

const API_TIMEOUT = 30000;

@Component({
  components: {
    V2Ja: () => import('@/privacy_policy/v2/ja/Index.vue'),
    V2Vi: () => import('@/privacy_policy/v2/vi/Index.vue'),
    V2En: () => import('@/privacy_policy/v2/en/Index.vue'),
    V2Id: () => import('@/privacy_policy/v2/id/Index.vue')
  }
})
export default class Page extends Vue {
  private isLoadingThirdParties: boolean = true;
  private isLoadingRevisionDate: boolean = true;
  public isLoadingComponent: boolean = true;
  public revisionDate: string = '';
  public thirdParties: ResponsePrivacyPolicy['thirdParties'] = {};

  @Prop({ type: Number, required: true })
  public version!: number;

  @Prop({ type: String, required: true })
  public language!: string;

  public get orgs(): string[] {
    return this.thirdParties[this.language] || [];
  }

  public get isDataFetching(): boolean {
    return this.isLoadingRevisionDate || this.isLoadingThirdParties;
  }

  private async fetchRevisionDate(): Promise<void> {
    return axios
      .get<void, AxiosResponse<ResponseRevisionDate>>(
        `${process.env.VUE_APP_API_ENDPOINT}/unauthorized/privacy_policy_revision_date`,
        { timeout: API_TIMEOUT }
      )
      .then(({ data: { revisionDate } }) => {
        this.revisionDate = revisionDate;
        this.isLoadingRevisionDate = false;
      });
  }

  private async fetchThirdParties(): Promise<void> {
    return axios
      .get<void, AxiosResponse<ResponsePrivacyPolicy>>(
        `${process.env.VUE_APP_API_ENDPOINT}/unauthorized/privacy_policy_third_parties`,
        {
          timeout: API_TIMEOUT
        }
      )
      .then(({ data: { thirdParties } }) => {
        this.thirdParties = thirdParties;
        this.isLoadingThirdParties = false;
      });
  }

  private async created(): Promise<void> {
    // 言語切り替え時にフラグを寝かせてロードする
    this.$watch(
      (): string => `${this.version}_${this.language}`,
      (): unknown => (this.isLoadingComponent = true)
    );

    // 全てのロードが完了したら親要素に伝える
    this.$watch(
      (): boolean => this.isLoadingComponent || this.isDataFetching,
      (value: boolean): unknown => this.$emit('isLoading', value)
    );

    try {
      await Promise.all([this.fetchRevisionDate(), this.fetchThirdParties()]);
      this.$emit('onPageLoaded', true);
    } catch (e) {
      console.error('API Request error', e); // eslint-disable-line no-console
    }
  }

  public onMount(): void {
    this.isLoadingComponent = false;
  }
}
